import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function OutputNode({ id, data, handleConf, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();

  return (
    <BaseNode
      id={id}
      icon="exit_to_app_rounded_icon"
      nodeData={{
        ...data,
        label: data?.label || msg({ id: 'field.output.label', defaultMessage: 'Sortie' })
      }}
      color="success"
      handleConf={handleConf}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <Stack spacing={0} sx={{ p: 1, width: '280px' }}>
        <CompactNodeField
          label={msg({ id: 'field.template.label', defaultMessage: 'Modèle de sortie' })}
          value={data?.template || msg({ id: 'field.none', defaultMessage: '-' })}
          shrink={true}
        />
      </Stack>
    </BaseNode>
  );
}

OutputNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    template: PropTypes.string
  }),
  handleConf: PropTypes.array.isRequired,
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
